import http from '@/http';

export default {
    list() {
        return http.get('/approver-types');
    },
    get(id) {
        return http.get(`/approver-types/${id}`);
    },
    remove(id) {
        return http.delete(`/approver-types/${id}`);
    },
    save(form) {
        return http.post('/approver-types', form);
    },
    update(id, form) {
        return http.put(`/approver-types/${id}`, form);
    },
};



// WEBPACK FOOTER //
// ./src/api/approverTypes.js